// ── 주소 복사 버튼 컴포넌트 ──────────────────────────────────────────────────

import React, { useState } from 'react';

// 클릭 시 클립보드에 주소 복사, 2초간 "복사됨" 상태 표시
//   iconSize/textSize 는 선택 — 안 넘기면 기본 크기 그대로다(목록의 '글자 크게'에서만 넘긴다).
export function CopyAddressButton({ address, onError, iconSize = 13, textSize = 12 }) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    const text = String(address || '').trim();
    if (!text) { onError?.(); return; }
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_e) {
      onError?.();
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      title="주소 복사"
      style={{
        background: 'none',
        border: `1px solid ${copied ? 'var(--mm-tone-green-border)' : 'var(--border)'}`,
        borderRadius: 6,
        padding: '3px 8px',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: textSize,
        fontWeight: 500,
        color: copied ? 'var(--mm-tone-green-text)' : 'var(--text-muted)',
        transition: 'all 0.2s',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      {copied ? (
        <>
          {/* 체크 아이콘 */}
          <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          복사됨
        </>
      ) : (
        <>
          {/* 복사 아이콘 */}
          <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
          복사
        </>
      )}
    </button>
  );
}
